import React, { useState } from "react";
import { FaAngleUp, FaAngleDown } from "react-icons/fa";
import { MdLabelImportant } from "react-icons/md";
const Content = ({ selectedCourse }) => {
  const [openIndex, setOpenIndex] = useState(null);
  const [selectedTopic, setSelectedTopic] = useState({ chapterId: null, topic: "" });

  const toggleVisibility = (id) => {
    setOpenIndex(openIndex === id ? null : id);
    setSelectedTopic({ chapterId: null, topic: "" });
  };

  const handleTopicClick = (chapterId, topic) => {
    setSelectedTopic({ chapterId, topic });
  };

  return (
    <div className="w-full flex flex-col gap-4 mt-4 relative">
      <h2 className="text-[#22BEFF] text-2xl font-bold">কন্টেন্ট প্রিভিউ</h2>

      {selectedCourse?.content?.map((item, index) => (
        <div key={index} className="w-full flex flex-col px-2 gap-2">
          {/* Chapter Header */}
          <div
            className={`flex justify-between items-center rounded-md p-2 cursor-pointer ${
              openIndex === index ? "border-2 border-[#043B55]" : ""
            }`}
            onClick={() => toggleVisibility(index)}
          >
            <h2
              className={`text-xl font-semibold ${
                openIndex === index ? "text-[#22BEFF]" : "text-[#abc7b9]"
              }`}
            >
              {item?.title}
            </h2>
            <span className="text-base text-[#22BEFF]">
              {openIndex === index ? <FaAngleUp /> : <FaAngleDown />}
            </span>
          </div>

          {/* Chapter Items */}
          {openIndex === index && (
            <div className="flex flex-col gap-2 pl-4">
              {item.items.map((topic, topicIndex) => (
                <div key={topicIndex} className="flex items-center cursor-pointer py-1" onClick={() => handleTopicClick(index, topic)}>
                  <MdLabelImportant className="text-[#22BEFF]"/>
                  <span className={`text-xl ${selectedTopic.chapterId === index && selectedTopic.topic === topic? "text-[#00E573]": "text-gray-200"}`}>
                     {topic}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}

      {/* Selected Topic Display */}
      {selectedTopic.topic && (
        <div className="mt-4 p-4 bg-[#0e1a1f] text-[#00E573] rounded-md border border-[#00E573]">
          <h3 className="font-semibold mb-2">Selected Topic:</h3>
          <p>{selectedTopic.topic}</p>
        </div>
      )}
    </div>
  );
};

export default Content;
